"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRedux = require("react-redux");

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _pep = _interopRequireDefault(require("./modules/pep"));

var _reducers = _interopRequireDefault(require("./redux/reducers"));

var _utils = require("./configuration/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PepAppWrapper = function PepAppWrapper() {
  var componentContent = document.querySelector((0, _utils.findAvaliableHtmlComponent)());
  var pepDictionary = (0, _utils.getDictionaryItems)(componentContent);
  document.querySelector('html').classList.add('no-smooth-scroll');
  var store = (0, _redux.createStore)(_reducers["default"], window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react["default"].createElement(_pep["default"], {
    pepDictionary: pepDictionary
  })), componentContent.querySelector('.component-content'));
};

var _default = PepAppWrapper;
exports["default"] = _default;